import { Component, signal } from '@angular/core';

import { RouterLink } from '@angular/router';
import { AuiIconComponent } from '@ral/ui:aui/icons';
import { StoryCardComponent } from '@storyteller/card';
import { StoryContainerComponent } from '@storyteller/container';
import { StoryDescriptionComponent } from '@storyteller/description';
import { StoryFeatureComponent } from '@storyteller/feature';
import { StoryImageComponent, StoryImageSourceComponent } from '@storyteller/image';
import { StoryTitleComponent } from '@storyteller/title';
import { EasyLeanKitComponent } from '../components';
import { AntBotCncComponent } from '../components/antbot-pro-cnc.component';
import { InquiryComponent, InquiryItemComponent } from '../components/inquiry.component';
import { MillBarFeederComponent } from '../components/mill-bar-feeder.component';
import { AppSimplyCarouselComponent } from '../components/simply-carousel.component';
import { AuiItemComponent } from '@ral/ui:aui/item';
@Component({
    selector: 'app-acp-system-page',
    imports: [
        StoryContainerComponent,
        StoryTitleComponent,
        StoryDescriptionComponent,
        StoryImageComponent,
        AuiItemComponent,
        InquiryComponent,
        MillBarFeederComponent,
        AntBotCncComponent,
        EasyLeanKitComponent,
        InquiryItemComponent,
        StoryContainerComponent,
        StoryTitleComponent,
        StoryDescriptionComponent,
        StoryImageComponent,
        InquiryComponent,
        MillBarFeederComponent,
        AntBotCncComponent,
        StoryFeatureComponent,
        InquiryItemComponent,
        AuiIconComponent,
        RouterLink,
        StoryImageSourceComponent,
        AppSimplyCarouselComponent,
        StoryCardComponent,
        StoryTitleComponent,
        StoryDescriptionComponent,
    ],
    template: `
        <header>
            <story-container
                [space]="'py-[20px] w500:py-[40px] md:py-[70px] lg:py-[100px]'"
                [skipTopPadding]="true"
                [skipSmallScreenTopPadding]="true"
            >
                <div class="detail-cover gap-6 md:gap-10">
                    <div class="img-block">
                        <story-image
                            fetchPriority="high"
                            [loading]="'eager'"
                            class="block aspect-[345/435] max-w-[500px] overflow-hidden rounded sm:aspect-[500/600]"
                            [alt]="'ACP System'"
                            aria-labelledby="acp-system-title"
                        >
                            <story-source
                                [src]="'assets/images/acp-system.jpg'"
                                [width]="500"
                                [height]="600"
                                media="(min-width: 640px)"
                            />
                            <story-source
                                [src]="'assets/images/acp-system.jpg'"
                                [width]="500"
                                [height]="600"
                                media="(min-width: 200px)"
                            />
                        </story-image>
                    </div>

                    <div class="title-block">
                        <div class="flex flex-col gap-2" id="acp-system-title">
                            <story-title [headingLevel]="1" className="story-font-headline1 pb-3 w500:pb-4"
                                >ACP systém
                            </story-title>
                            <story-description>
                                Inovativní řešení pro CNC výrobu s&nbsp;flexibilní automatizací od kusu po&nbsp;sérii.
                            </story-description>
                        </div>
                        <div class="flex flex-col gap-1 pb-[11px] pt-6 w460:flex-row md:gap-2 md:pt-8">
                            <div>
                                <button auiItem [size]="'40'" [color]="'primary'" (click)="openInquiryForm()">
                                    <span auiItemLabel>Nezávazná poptávka</span>
                                </button>
                            </div>
                            <a auiItem [size]="'40'" [color]="'gray'" auiStyle="decent" [routerLink]="['/', 'acp-system']" fragment="description">
                                    <span auiItemLabel>Chci více informací</span>
                            </a>
                        </div>
                    </div>
                    <div class="features-block self-end">
                        <div class="w500:grid-cols-2 grid grid-cols-1 gap-5 lg:gap-10">
                            <div>
                                <story-feature>
                                    <aui-icon icon="hexagon-nodes" class="text-[28px]" />
                                    <story-title [headingLevel]="2" className="story-font-headline3 pb-1"
                                        >Obrobení z šesti stran</story-title
                                    >
                                    <story-description>
                                        Obsahuje stanici pro uchopení dílu k&nbsp;druhému upnutí.
                                    </story-description>
                                </story-feature>
                            </div>
                            <div>
                                <story-feature>
                                    <aui-icon icon="arrow-up-right-dots" class="text-[28px]" />
                                    <story-title [headingLevel]="2" className="story-font-headline3 pb-1"
                                        >Velká rozmanitost polotovarů</story-title
                                    >
                                    <story-description>
                                        Automatická výměna svěráku podle velikosti polotovaru.
                                    </story-description>
                                </story-feature>
                            </div>
                        </div>
                    </div>
                </div>
            </story-container>
        </header>
        <section>
            <div class="-top:5 w500:-top-12 relative">
                <div id="description" class="relative -top-12 lg:top-[-100px]"></div>
            </div>
            <story-container [skipTopPadding]="true" [skipSmallScreenTopPadding]="true">
                <div class="flex flex-col-reverse items-center gap-5 md:grid md:grid-cols-2 lg:gap-10">
                    <div id="acp-system-description">
                        <story-title [headingLevel]="2" className="story-font-headline2 pb-6"
                            >Produktový popis</story-title
                        >
                        <story-description class="block">
                            ACP System přináší pružnou automatizaci CNC výroby od kusu po sérii bez kompromisů. Díky
                            přesnému a silnému upínání snadno zvládnete rozmanité polotovary. Systém umožňuje obrábění
                            ze všech šesti stran, rychlé přepnutí výroby a spuštění nočního bezobslužného provozu.
                            <br /><br />
                            Moderní softwarové rozhraní poskytuje přehled o práci, prioritách i stavu zakázek. Frontu
                            úloh vytvoříte pohodlně i na dálku. Intuitivní systém vede obsluhu, snižuje chybovost a
                            proměňuje flexibilní výrobu v předvídatelný výkon.Rychlé zprovoznění, krátké časy upnutí a
                            vzdálená příprava úloh zvyšují kapacitu bez nutnosti rozšiřovat tým a zkracují dodací
                            termíny.
                            <br /><br />
                            Výsledkem je vyšší produktivita, nižší náklady a hotový výrobek rychleji než kdy dřív.
                        </story-description>
                    </div>
                    <div>
                        <story-image
                            class="block aspect-[562/564] overflow-hidden rounded"
                            aria-labelledby="acp-system-description"
                            [alt]="'ACP System model'"
                        >
                            <story-source [src]="'assets/images/acp-system.png'" [width]="562" [height]="564" />
                        </story-image>
                    </div>
                </div>
            </story-container>
        </section>
        <section class="overflow-hidden">
            <story-container [space]="'w500:py-10'" [skipTopPadding]="true" [skipSmallScreenTopPadding]="true">
                <app-carousel
                    [slides]="[
                        {
                            url: 'assets/images/acp-system/FM1A0201.JPG',
                            isPortrait: false,
                            alt: 'ACP System | Fotka 1',
                        },
                        {
                            url: 'assets/images/acp-system/FM1A0197.JPG',
                            isPortrait: false,
                            alt: 'ACP System | Fotka 2',
                        },
                        {
                            url: 'assets/images/acp-system/FM1A0198.JPG',
                            isPortrait: false,
                            alt: 'ACP System | Fotka 3',
                        },
                        {
                            url: 'assets/images/acp-system/FM1A0179.JPG',
                            isPortrait: true,
                            alt: 'ACP System | Fotka 4',
                        },
                        {
                            url: 'assets/images/acp-system/FM1A0190.JPG',
                            isPortrait: false,
                            alt: 'ACP System | Fotka 5',
                        },
                        {
                            url: 'assets/images/acp-system/FM1A0162.JPG',
                            isPortrait: false,
                            alt: 'ACP System | Fotka 6',
                        },
                        {
                            url: 'assets/images/acp-system/FM1A0170.JPG',
                            isPortrait: true,
                            alt: 'ACP System | Fotka 7',
                        },
                        {
                            url: 'assets/images/acp-system/FM1A0155.JPG',
                            isPortrait: false,
                            alt: 'ACP System | Fotka 8',
                        },
                        {
                            url: 'assets/images/acp-system/FM1A0123.JPG',
                            isPortrait: false,
                            alt: 'ACP System | Fotka 9',
                        },
                        {
                            url: 'assets/images/acp-system/FM1A0135.JPG',
                            isPortrait: false,
                            alt: 'ACP System | Fotka 10',
                        },
                        {
                            url: 'assets/images/acp-system/FM1A0118.JPG',
                            isPortrait: true,
                            alt: 'ACP System | Fotka 11',
                        },
                        {
                            url: 'assets/images/acp-system/FM1A0122.JPG',
                            isPortrait: false,
                            alt: 'ACP System | Fotka 12',
                        },
                        {
                            url: 'assets/images/acp-system/FM1A0089.JPG',
                            isPortrait: false,
                            alt: 'ACP System | Fotka 13',
                        },
                        {
                            url: 'assets/images/acp-system/FM1A0092.JPG',
                            isPortrait: false,
                            alt: 'ACP System | Fotka 14',
                        },
                        {
                            url: 'assets/images/acp-system/FM1A0075.JPG',
                            isPortrait: false,
                            alt: 'ACP System | Fotka 15',
                        },
                        {
                            url: 'assets/images/acp-system/FM1A0076.JPG',
                            isPortrait: false,
                            alt: 'ACP System | Fotka 16',
                        },
                        {
                            url: 'assets/images/acp-system/FM1A0083.JPG',
                            isPortrait: false,
                            alt: 'ACP System | Fotka 17',
                        },
                        {
                            url: 'assets/images/acp-system/FM1A0069.JPG',
                            isPortrait: false,
                            alt: 'ACP System | Fotka 18',
                        },
                    ]"
                ></app-carousel>
            </story-container>
        </section>
        <section>
            <story-container [space]="'pt-12 w500:py-10'" [skipTopPadding]="true" [skipSmallScreenTopPadding]="true">
                <story-title [headingLevel]="3" className="story-font-headline2 pb-6 md:pb-7 lg:pb-8"
                    >Technické specifikace</story-title
                >

                <table class="w-full table-fixed text-left">
                    <thead>
                        <tr>
                            <th class="pb-2 pt-6 font-semibold">Parametr</th>
                            <th aria-label="Hodnota"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="tr">
                            <th>Typ robota</th>
                            <td>Fanuc R-1000iA/100F</td>
                        </tr>
                        <tr class="tr">
                            <th>Nosnost robota</th>
                            <td>100&nbsp;kg</td>
                        </tr>
                        <tr class="tr">
                            <th>Dosah</th>
                            <td>2000&nbsp;mm</td>
                        </tr>
                        <tr class="tr">
                            <th>Typ upínání v&nbsp;CNC</th>
                            <td>Nulový bod Gressel</td>
                        </tr>
                        <tr class="tr">
                            <th>Zakládaní do CNC</th>
                            <td>svěrák s upnutým polotovarem</td>
                        </tr>
                        <tr class="tr">
                            <th>Síla upnutí</th>
                            <td>20-30&nbsp;kN</td>
                        </tr>
                        <tr class="tr">
                            <th>Obrábění 6 stran</th>
                            <td>ano</td>
                        </tr>
                        <tr class="tr">
                            <th>Rozsah polotovarů</th>
                            <td>max. 200x200x200&nbsp;mm, Ø 200&nbsp;mm</td>
                        </tr>
                        <tr class="tr">
                            <th>Hmotnost kusu</th>
                            <td>max. 35&nbsp;kg</td>
                        </tr>
                        <tr class="tr">
                            <th>Čas nastavení zakázky</th>
                            <td>120&nbsp;s</td>
                        </tr>
                        <tr class="tr">
                            <th>Kapacita jednoho zásobníku</th>
                            <td>18 - 100&nbsp;ks dle rastru</td>
                        </tr>
                        <tr class="tr">
                            <th>Bezpečnost</th>
                            <td>světelné závory, oplocení</td>
                        </tr>
                        <tr class="tr">
                            <th>Sledování stavu</th>
                            <td>alarmy, notifikace</td>
                        </tr>

                        <tr class="tr">
                            <th>Zástavbový prostor</th>
                            <td>3100×3800×2700&nbsp;mm</td>
                        </tr>
                        <tr class="tr">
                            <th>Napětí</th>
                            <td>400&nbsp;V</td>
                        </tr>
                        <tr class="tr">
                            <th>Provozní tlak vzduchu</th>
                            <td>6 - 8&nbsp;bar</td>
                        </tr>
                    </tbody>
                </table>
                <h4 class="pb-2 pt-6 font-semibold">Technický popis</h4>

                <story-description class="block max-w-[780px]">
                    Systém vyžaduje stroj vybavený I/O rozhraním, podporou M-kódů, přístupem k signálů m dveří, přívodem
                    stlačeného vzduchu do stolu CNC a mechanismem pro automatické otevírání dveří nebo okna. Softwarově
                    systém obsahu je funkce pro správu fronty úloh, včetně sledování stavu zakázek, priorit a průběhu
                    zpracování, přičemž frontu lze vytvářet a upravovat i na dálku.
                </story-description>
            </story-container>
        </section>
        <section>
            <story-container [space]="'pt-12 w500:py-10'" [skipTopPadding]="true" [skipSmallScreenTopPadding]="true">
                <story-title [headingLevel]="3" className="story-font-headline2 pb-6 md:pb-7 lg:pb-8"
                    >Ke stažení</story-title
                >
                <div class="flex flex-wrap gap-6 lg:gap-8">
                    <div class="min-w-[245px] max-w-[320px] flex-grow">
                        <story-card>
                            <aui-icon icon="file-pdf" class="text-[32px]" />
                            <story-title [headingLevel]="4" className="@lg:story-font-headline4 story-font-headline4"
                                >Technická specifikace</story-title
                            >
                            <story-description
                                [className]="'@lg:leading-[28px] @lg:max-w-[460px] aui-font-regular-14 leading-[1.5]'"
                            >
                                Tento soubor obsahuje rozměry a technické specifikace pro ACP System.
                            </story-description>
                            <a
                                auiItem
                                [size]="'40'"
                                [color]="'primary'"
                                [auiStyle]="'decent'"
                                [fullWidth]="true"
                                [href]="'/assets/files/acp-system_tech-spec.pdf'"
                                download
                                aria-label="Stáhnout specifikaci (PDF, méně než 1 MB)"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <span auiItemLabel>Stáhnout specifikaci</span>
                            </a>
                        </story-card>
                    </div>
                    <div class="min-w-[245px] max-w-[320px] flex-grow">
                        <story-card>
                            <aui-icon icon="file-pdf" class="text-[32px]" />
                            <story-title [headingLevel]="4" className="@lg:story-font-headline4 story-font-headline4"
                                >Technický výkres</story-title
                            >
                            <story-description
                                [className]="'@lg:leading-[28px] @lg:max-w-[460px] aui-font-regular-14 leading-[1.5]'"
                            >
                                Tento soubor obsahuje technický výkres pro ACP System.
                            </story-description>
                            <a
                                auiItem
                                [size]="'40'"
                                [color]="'primary'"
                                [auiStyle]="'decent'"
                                [fullWidth]="true"
                                [href]="'/assets/files/acp-system_tech-vykres.pdf'"
                                download
                                aria-label="Stáhnout výkres (PDF, méně než 1 MB)"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <span auiItemLabel>Stáhnout výkres</span>
                            </a>
                        </story-card>
                    </div>
                </div>
            </story-container>
        </section>
        <section>
            <story-container>
                <story-title [headingLevel]="2" className="story-font-headline1 pb-12 md:pb-16 lg:pb-20"
                    >Prohlédněte si ostatní produkty</story-title
                >
                <div class="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-3">
                    <div>
                        <app-mill-bar-feeder></app-mill-bar-feeder>
                    </div>
                    <div>
                        <app-antbot-pro-cnc></app-antbot-pro-cnc>
                    </div>
                    <div>
                        <app-easy-lean-kit></app-easy-lean-kit>
                    </div>
                </div>
            </story-container>
        </section>
        @if (isInquiryFormOpened()) {
            <app-inquiry-form (closeInquiry)="closeInquiryForm()" [productName]="'ACP Systém'">
                <app-inquiry-item productName="ACP Systém" [priceWithoutVat]="0"></app-inquiry-item>
            </app-inquiry-form>
        }
    `,
})
export class AcpSystemPageComponent {
    isInquiryFormOpened = signal<boolean>(false);

    openInquiryForm() {
        this.isInquiryFormOpened.set(true);
    }

    closeInquiryForm() {
        this.isInquiryFormOpened.set(false);
    }
}
